import * as React from "react";
import { observer } from "mobx-react";
import { Icon } from "./Icon";

@observer
export class LogOutIcon extends Icon {

	render() {
		return <Icon {...this.props}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
				<path d="M32,34v1c0,0.5-0.5,1-1,1h-5V14c0-1.1-0.6-2.2-1.3-2.5L16.1,8H31c0.5,0,1,0.5,1,1v1h2V8c0-1.1-0.9-2-2-2H11c0,0,0,0,0,0c-0.6,0-1,0.6-1,1.5V8v27.5V36c0,0.7,0.4,1.3,0.9,1.7c0.1,0.1,0.2,0.2,0.3,0.2l13.4,5.6c0.7,0.3,1.3-0.4,1.3-1.5v-4h6c1.1,0,2-0.9,2-2v-2H32z" />
				<polygon points="34.2,28 38,22 34.2,16 30.9,16 34.7,22 30.9,28 " />
			</svg>
		</Icon>;
	}
}